import { RowSelectionProvider } from "@/components/data-table/context/RowSelectionProvider";
import { ContractorsPlannedHoursWizardTabs } from "@/modules/contractorsPlannedHoursWizard/components/ContractorsPlannedHoursWizardTabs";
import { useContractorsPlannedHoursWizardBreadcrumbItems } from "@/modules/contractorsPlannedHoursWizard/hooks/useContractorsPlannedHoursWizardBreadcrumbItems";
import { useContractorsPlannedHoursWizardColumnOverrides } from "@/modules/contractorsPlannedHoursWizard/hooks/useContractorsPlannedHoursWizardColumnOverrides";

export const ContractorsPlannedHoursWizardDirectory = () => {
  const breadcrumbItems = useContractorsPlannedHoursWizardBreadcrumbItems();
  const columnOverrides = useContractorsPlannedHoursWizardColumnOverrides();

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <RowSelectionProvider>
        <ContractorsPlannedHoursWizardTabs
          breadcrumbItems={breadcrumbItems}
          columnOverrides={columnOverrides}
        />
      </RowSelectionProvider>
    </div>
  );
};
